module.exports = __webpack_public_path__ + "static/img/xszz.c5eeada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/xszz.png
// module id = lIx5
// module chunks = 41